<template>
    <div>

        <Header title="Odběrná místa">
      
        </Header>

        <SupplyPointMobileList class="mb-4"/>
    </div>
</template>

<script>
import Header from "../../Module/Common/UI/Header.vue"
import SupplyPointMobileList from "../SupplyPoint/Component/SupplyPointMobileList.vue";

export default {

    components: {
        Header,
        SupplyPointMobileList
    },

}
</script>


